import { render, staticRenderFns } from "./DashboardConfigurationWrapper.vue?vue&type=template&id=16a16e0f&lang=pug&"
import script from "./DashboardConfigurationWrapper.vue?vue&type=script&lang=js&"
export * from "./DashboardConfigurationWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports